import { render } from "./tugas_pokok.vue?vue&type=template&id=c2101dcc"
import script from "./tugas_pokok.vue?vue&type=script&lang=js"
export * from "./tugas_pokok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__